import React, { useContext, useEffect, useState } from 'react';
import { Routes, Route } from 'react-router-v6';
// import PageNotFound from "error_pages/NotFound"
import Container from 'layout/container';
import Login from 'pages/authentication';
import Register from 'pages/authentication/register';
import ForgotPassword from 'pages/authentication/forgot-password';
import ResetPassword from 'pages/authentication/reset-password';
import ConfirmEmail from 'pages/authentication/confirm-email';
// import { keys, getFromStorage } from "utils/localStorage"
// import { useNavigate, useLocation } from "react-router-v6"
import { routes } from './routes-config';
import AuthService from 'api-services/auth-service';
import eventEmitter from 'utilities/event-emitter';
//import PageNotFound from 'react-router-v6/page-not-found';
import Pricing from 'pages/pricing';
import ChatBotContext from 'hooks/chat-bot-context';
import ChatBotList from 'pages/chatbot-list';
import Thankyou from 'pages/authentication/thankyou';

const Router = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(AuthService.isAuthenticated());
  const { selectedBot } = useContext(ChatBotContext);

  // Use useEffect to listen for changes in isAuthenticated
  useEffect(() => {
    const checkAuthentication = () => {
      setIsAuthenticated(AuthService.isAuthenticated());
    };

    // Add an event listener, or any mechanism that AuthService provides
    // to notify changes in authentication status.
    eventEmitter.on('authenticationChange', checkAuthentication);
    //AuthService.on('authenticationChange', checkAuthentication);

    // Clean up the listener when the component unmounts.
    return () => {
      eventEmitter.off('authenticationChange', checkAuthentication);
      //AuthService.off('authenticationChange', checkAuthentication);
    };
  }, []);

  return (
    <Routes>
      {!isAuthenticated && <>
        <Route path='/login' element={<Login />} key='Login' exact />
        <Route path='/register' element={<Register />} key='Register' exact />
        <Route path='/thank-you' element={<Thankyou />} key='ThankYou' exact />
        <Route path='/confirm-email/:token' element={<ConfirmEmail />} key='ConfirmEmail' exact />
        
        <Route path='/forgot-password' element={<ForgotPassword />} key='forgot-password' exact />
        <Route path='/password-change/:hash' element={<ResetPassword />} key='reset-password' exact />
        <Route path='/plans' element={<Pricing />} key='pricing' exact />
      </>}

      <Route path='/' element={isAuthenticated ? <Container /> : <Login />} key='Login' exact />
      <Route path="*" element={isAuthenticated?<Container/>:<Login />} />

      <Route path="/*" element={isAuthenticated ? <Container /> : <Login />}>
        {routes?.map(({ component: Component, ...route }) => {
          return Array.isArray(route?.children) && route.children.length > 0 ?(
            <Route path={route.route.substring(1)} key={route.title}>
              {route.children.map(({ component: SubComponent, ...subRoute }) => (
                <Route path={subRoute.route.substring(1)} key={subRoute.title} element={<SubComponent />} />
              ))}
            </Route>
          ) : (
            <Route path={route.route.substring(1)} key={route.title} element={
              route.is_base_route ? <Component />: selectedBot === null ? <ChatBotList />: <Component />
            } />
          );
        })}
      </Route>
    </Routes>
  );
};

export default Router;
